import {
  Button,
  Collapse,
  createStyles,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Theme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectActiveGroupMembers } from "../../redux/slices/cleverlynkSlice";

import { useTranslation } from "react-i18next";
import "../../i18n/config";

interface ICoverageList {
  onConfirm: (id: string) => void;
}

const CoverageList = ({ onConfirm }: ICoverageList) => {
  const [selected, setSelected] = useState<{ name: string; id: string } | undefined>(undefined);

  const { t } = useTranslation("deliveryinput");

  const activeGroupMembers = useSelector(selectActiveGroupMembers);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      listItem: {
        marginBottom: 8,
        boxShadow: "1pt 1pt 2px 1px #ccc8c85e",
        borderRadius: 5,
        "&.selected": {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.contrastText,
        },
      },
    })
  );
  const classes = useStyles();

  const scrollDown = () => {
    const elem = document.getElementById("group-selector-content");
    setTimeout(() => {
      if (elem) {
        elem.scrollTo({
          top: window.screen.height,
          behavior: "smooth",
        });
      }
    }, 200);
  };

  return (
    <React.Fragment>
      <List>
        {activeGroupMembers
          .filter(c => c.open)
          .map(m => (
            <ListItem
              key={`coveragelistitem-${m.id}`}
              button
              onClick={() => {
                scrollDown();
                setSelected({ name: m.name ?? "", id: m.id ?? "" });
              }}
              className={`${selected?.id === m.id ? "selected" : ""} ${classes.listItem}`}>
              <ListItemText primary={m.name} />
            </ListItem>
          ))}
      </List>
      <Collapse in={!!selected}>
        <Grid container justifyContent="flex-end">
          <Button
            color="primary"
            variant="contained"
            style={{ width: "100%", height: "40px" }}
            onClick={() => onConfirm(selected?.id!)}>
            {t("coverageMap.confirm")}
          </Button>
        </Grid>
      </Collapse>
    </React.Fragment>
  );
};
export default CoverageList;
